module.exports = __webpack_public_path__ + "static/media/art50.2aa5ec20.jpg";